import { useQuery } from '@tanstack/react-query';
import { getOrgTitles } from '../../../api/Terminal/OrgTitle';
import { ReactQueryKey } from '../../../constants/ReactQueryKeys';
import { TitleInterface } from '../../../types/Account';
import { QueryParamsInterface } from '../../../types/Shared';

export const useOrgTitles = ({
  onSuccess,
  onError,
  params,
}: {
  onSuccess?: (data: any) => void;
  onError?: (err: any) => void;
  params?: QueryParamsInterface;
}) => {
  return useQuery(
    [ReactQueryKey.GET_ORG_TITLES, params],
    () => getOrgTitles({ sortBy: 'desc', orderBy: 'createdAt', ...params }),
    {
      onSuccess,
      onError,
      keepPreviousData: true,
      staleTime: 30000,
    }
  );
};

export const useTitleById = (id?: number) => {
  const accountTitles = useOrgTitles({});

  const matchedTitle = accountTitles?.data?.data?.find(
    (title: TitleInterface) => title.id === id
  );

  const getTitle = (id: number) => {
    const matchedTitle = accountTitles?.data?.data?.find(
      (title: TitleInterface) => title.id === id
    );
    return matchedTitle;
  };

  return { matchedTitle, getTitle };
};

export const useTitleByName = (name?: string) => {
  const accountTitles = useOrgTitles({});

  const matchedTitle = accountTitles?.data?.data?.find(
    (title: TitleInterface) => title.name === name
  );

  const getTitle = (name: string) => {
    const matchedTitle = accountTitles?.data?.data?.find(
      (title: TitleInterface) => title.name === name.trim()
    );
    return matchedTitle;
  };

  return { matchedTitle, getTitle };
};
